<template>
    <div v-if="componentData" class="small-wrapper">
        <div class=" Quote Quote-small">
            <img v-if="componentData.image?.data?.attributes?.url" :src="componentData.image.data.attributes.url"  :alt="componentData.image.data.attributes.alternativeText"/>
            <div class="Quote__quote">“{{componentData.title}}”</div>
            <p class="Quote__name"> {{componentData.name}} </p>
            <p class="Quote__organization"> {{componentData.organisation}} </p>
        </div>
    </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'

export default defineComponent({
    props:{
        componentData: {
            type: Object,
            required: false
        },
    },
    setup(props) {
        const homeurl: string = import.meta.env.VITE_API_URL;

        return {
            homeurl
        };
    }
})

</script>
